import React, { useState } from 'react'
import Icon from './Icons'
import { isDevMode } from '../services/emailService'

export default function StepEmailConfirmation({
  email,
  onResend,
  onConfirm,        // appelé après confirmation (dev mode ou vrai token URL)
  resendLoading,
  resendCount,
}) {
  const [devLoading, setDevLoading] = useState(false)
  const devMode = isDevMode()

  async function handleDevConfirm() {
    setDevLoading(true)
    await new Promise((r) => setTimeout(r, 600))
    setDevLoading(false)
    onConfirm()
  }

  return (
    <div className="step-enter max-w-md mx-auto text-center">

      {/* Illustration */}
      <div className="flex justify-center mb-6">
        <div className="w-20 h-20 rounded-full bg-blue-50 border-2 border-blue-100 flex items-center justify-center animate-pulse-soft">
          <Icon name="mail" className="w-9 h-9 text-blue-500" />
        </div>
      </div>

      {/* Titre */}
      <h2 className="text-xl font-bold text-slate-800 mb-2">
        Vérifiez votre boîte mail
      </h2>
      <p className="text-sm text-slate-500 leading-relaxed mb-1">
        Un email de confirmation a été envoyé à
      </p>
      <p className="text-sm font-semibold text-slate-700 mb-5 break-all">
        {email}
      </p>

      {/* Instructions */}
      <div className="text-left space-y-3 bg-slate-50 border border-slate-200 rounded-xl p-4 mb-6">
        {[
          'Ouvrez l\'email reçu de la part de E2I Solutions.',
          'Cliquez sur le lien de confirmation.',
          'Votre estimation s\'affichera immédiatement.',
        ].map((step, i) => (
          <div key={i} className="flex items-start gap-3">
            <div className="w-5 h-5 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">
              {i + 1}
            </div>
            <p className="text-sm text-slate-600">{step}</p>
          </div>
        ))}
      </div>

      {/* Bloc dev mode */}
      {devMode && (
        <div className="mb-6 p-4 rounded-xl border-2 border-dashed border-amber-300 bg-amber-50">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="warning" className="w-4 h-4 text-amber-500" />
            <span className="text-xs font-semibold text-amber-700 uppercase tracking-wide">
              Mode développement
            </span>
          </div>
          <p className="text-xs text-amber-700 mb-3">
            Aucun email réel n'est envoyé. Cliquez ci-dessous pour simuler la validation.
          </p>
          <button
            type="button"
            onClick={handleDevConfirm}
            disabled={devLoading}
            className="btn-primary w-full bg-amber-500 hover:bg-amber-600 text-sm"
          >
            {devLoading ? (
              <span className="flex items-center gap-2 justify-center">
                <LoadingSpinner /> Simulation…
              </span>
            ) : (
              <>
                <Icon name="check-circle" className="w-4 h-4" />
                Simuler la confirmation email
              </>
            )}
          </button>
        </div>
      )}

      {/* Renvoyer l'email */}
      <div className="flex flex-col items-center gap-2">
        <p className="text-xs text-slate-500">
          Vous n'avez pas reçu l'email ?{' '}
          <span className="text-slate-400">(Pensez à vérifier vos spams.)</span>
        </p>
        <button
          type="button"
          onClick={onResend}
          disabled={resendLoading || resendCount >= 3}
          className="
            inline-flex items-center gap-2 text-sm font-medium text-blue-600
            hover:text-blue-700 disabled:opacity-40 disabled:cursor-not-allowed
            transition-colors duration-150
          "
        >
          {resendLoading ? (
            <>
              <LoadingSpinner className="w-3.5 h-3.5 text-blue-600" />
              Renvoi en cours…
            </>
          ) : (
            <>
              <Icon name="refresh" className="w-3.5 h-3.5" />
              Renvoyer l'email
              {resendCount > 0 && (
                <span className="text-xs text-slate-400">
                  ({resendCount}/3)
                </span>
              )}
            </>
          )}
        </button>
        {resendCount >= 3 && (
          <p className="text-xs text-slate-400">
            Nombre maximum de renvois atteint. Contactez-nous à{' '}
            <a
              href="mailto:contact@e2i-solutions.com"
              className="text-blue-500 hover:underline"
            >
              contact@e2i-solutions.com
            </a>
          </p>
        )}
      </div>
    </div>
  )
}

function LoadingSpinner() {
  return (
    <svg
      className="animate-spin w-4 h-4"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  )
}
